export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  categorySlug: string;
  cover: string;
  year: number;
  rating: number;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  region: string;
  type: 'movie' | 'tv';
  episodes?: number;
  updateStatus?: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  slug: string;
  name: string;
  count: number;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'dongzuo', name: '动作片', count: 128, icon: 'ri-fire-line' },
  { slug: 'xiju', name: '喜剧片', count: 96, icon: 'ri-emotion-laugh-line' },
  { slug: 'aiqing', name: '爱情片', count: 85, icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', count: 72, icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖片', count: 54, icon: 'ri-ghost-line' },
  { slug: 'juqing', name: '剧情片', count: 143, icon: 'ri-film-line' },
  { slug: 'xuanyi', name: '悬疑片', count: 67, icon: 'ri-search-eye-line' },
  { slug: 'fanzui', name: '犯罪片', count: 58, icon: 'ri-police-car-line' },
  { slug: 'zhanzheng', name: '战争片', count: 41, icon: 'ri-shield-flash-line' },
  { slug: 'donghua', name: '动画片', count: 89, icon: 'ri-palette-line' },
  { slug: 'jilupian', name: '纪录片', count: 36, icon: 'ri-camera-lens-line' },
  { slug: 'dianshiju', name: '电视剧', count: 112, icon: 'ri-tv-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球2',
    titleEn: 'The Wandering Earth II',
    category: '科幻片',
    categorySlug: 'kehuan',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronauts%20and%20planets%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster%20aesthetic&width=600&height=800&seq=movie-cover-01&orientation=portrait',
    year: 2023,
    rating: 8.3,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '173分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['硬科幻', '国产大片', '灾难', '太空'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-2',
    title: '满江红',
    titleEn: 'Full River Red',
    category: '剧情片',
    categorySlug: 'juqing',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%20with%20ancient%20Chinese%20soldiers%20in%20courtyard%2C%20dark%20red%20tone%2C%20cinematic%20lighting%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-02&orientation=portrait',
    year: 2023,
    rating: 7.8,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['历史', '悬疑', '喜剧', '古装'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-3',
    title: '孤注一掷',
    titleEn: 'No More Bets',
    category: '犯罪片',
    categorySlug: 'fanzui',
    cover: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20atmosphere%2C%20gambling%20theme%2C%20suspenseful%20lighting%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-03&orientation=portrait',
    year: 2023,
    rating: 7.5,
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外卷入境外诈骗工厂的陷阱。他们能否逃脱？国内警方又如何跨境追捕？一场孤注一掷的较量就此展开。',
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    duration: '130分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['犯罪', '诈骗', '现实题材', '悬疑'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-4',
    title: '速度与激情10',
    titleEn: 'Fast X',
    category: '动作片',
    categorySlug: 'dongzuo',
    cover: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20fast%20cars%20and%20explosion%20in%20city%2C%20dynamic%20composition%2C%20warm%20orange%20tone%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-04&orientation=portrait',
    year: 2023,
    rating: 7.2,
    description: '唐老大及其家族必须面对有史以来最致命的对手——从过去的阴影中浮现的但丁，他为了报仇雪恨而立下血誓，要摧毁这个家庭及唐老大所爱的一切。',
    director: '路易斯·莱特里尔',
    cast: ['范·迪塞尔', '米歇尔·罗德里格兹', '杰森·莫玛', '布丽·拉尔森'],
    duration: '141分钟',
    region: '美国',
    type: 'movie',
    tags: ['动作', '飙车', '冒险', '好莱坞'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-5',
    title: '八角笼中',
    titleEn: 'Octagonal',
    category: '剧情片',
    categorySlug: 'juqing',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%20about%20MMA%20fighting%20and%20poor%20children%2C%20warm%20earthy%20tones%2C%20inspirational%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-05&orientation=portrait',
    year: 2023,
    rating: 7.6,
    description: '向腾辉倾注心血想把当地无人照料的孩子培养成才，这让生活本没有出路的孩子们看到了一丝通向未来的曙光。然而，随着往日的表演视频被爆出，这些"残忍、血腥"的画面刺激了不明真相的人们的神经。',
    director: '王宝强',
    cast: ['王宝强', '陈永胜', '史彭元', '王迅'],
    duration: '117分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['励志', '体育', '现实题材', '格斗'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-6',
    title: '消失的她',
    titleEn: 'Lost in the Stars',
    category: '悬疑片',
    categorySlug: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20mysterious%20woman%20and%20dark%20sea%20vibe%2C%20deep%20blue%20night%20atmosphere%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-06&orientation=portrait',
    year: 2023,
    rating: 7.4,
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，妻子再次现身，何非却坚持眼前的女人并非自己的妻子。夫妻二人似乎都有不可告人的秘密。',
    director: '崔睿、刘翔',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '121分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['悬疑', '反转', '犯罪', '心理'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-7',
    title: '人生路不熟',
    titleEn: 'Godspeed',
    category: '喜剧片',
    categorySlug: 'xiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20road%20trip%20movie%20poster%20with%20family%20and%20truck%2C%20bright%20warm%20colors%2C%20fun%20vibe%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-07&orientation=portrait',
    year: 2023,
    rating: 7.1,
    description: '一家四口意外开启一段有笑有泪的卡车之旅。卡车司机周东海非常不看好准女婿万一帆，为讨未来岳父欢心，万一帆越努力越"翻车"，准岳母和女友也为调解这对冤家费尽心思。',
    director: '易小星',
    cast: ['乔杉', '范丞丞', '马丽', '张婧仪'],
    duration: '100分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['喜剧', '公路', '家庭', '搞笑'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-8',
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    category: '剧情片',
    categorySlug: 'juqing',
    cover: 'https://readdy.ai/api/search-image?query=Biographical%20movie%20poster%20with%20nuclear%20explosion%20and%20scientist%20portrait%2C%20dark%20dramatic%20lighting%2C%20black%20and%20white%20atmosphere%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-08&orientation=portrait',
    year: 2023,
    rating: 8.8,
    description: '随着世界大战的阴云笼罩全球，美国物理学家罗伯特·奥本海默领导曼哈顿计划，成功研制出世界上第一颗原子弹。然而这项发明也给他带来了前所未有的道德困境。',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    duration: '180分钟',
    region: '美国',
    type: 'movie',
    tags: ['传记', '历史', '战争', '科学'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv-1',
    title: '狂飙',
    titleEn: 'The Knockout',
    category: '电视剧',
    categorySlug: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20police%20and%20gangster%20theme%2C%20dark%20suspenseful%20atmosphere%2C%20clean%20white%20background%2C%20high%20quality%20TV%20show%20poster&width=600&height=800&seq=tv-cover-01&orientation=portrait',
    year: 2023,
    rating: 9.1,
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    duration: '45分钟/集',
    region: '中国大陆',
    type: 'tv',
    episodes: 39,
    updateStatus: '已完结',
    tags: ['犯罪', '扫黑', '剧情', '国产剧'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv-2',
    title: '三体',
    titleEn: 'Three-Body',
    category: '电视剧',
    categorySlug: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20cosmic%20theme%20and%20three%20suns%2C%20mysterious%20atmosphere%2C%20clean%20white%20background%2C%20high%20quality%20TV%20show%20poster&width=600&height=800&seq=tv-cover-02&orientation=portrait',
    year: 2023,
    rating: 8.7,
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘摇。纳米科学家汪淼被警官史强带入联合作战中心，潜入名为"科学边界"的神秘组织，揭开了地外文明"三体"世界的神秘面纱。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    duration: '45分钟/集',
    region: '中国大陆',
    type: 'tv',
    episodes: 30,
    updateStatus: '已完结',
    tags: ['科幻', '国产剧', '刘慈欣', '悬疑'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv-3',
    title: '漫长的季节',
    titleEn: 'The Long Season',
    category: '电视剧',
    categorySlug: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20drama%20TV%20series%20poster%20set%20in%20northeast%20China%2C%20nostalgic%20autumn%20tone%2C%20clean%20white%20background%2C%20high%20quality%20TV%20show%20poster&width=600&height=800&seq=tv-cover-03&orientation=portrait',
    year: 2023,
    rating: 9.4,
    description: '出租车司机王响和妹夫龚彪在追查套牌车的过程中，发现了18年前一桩悬案的线索。他们决定查找真相，结果发现过去和现在紧密相连，每个人都无法逃脱命运的捉弄。',
    director: '辛爽',
    cast: ['范伟', '秦昊', '李庚希', '陈明昊'],
    duration: '60分钟/集',
    region: '中国大陆',
    type: 'tv',
    episodes: 12,
    updateStatus: '已完结',
    tags: ['悬疑', '剧情', '年代', '国产剧'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'tv-4',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    category: '电视剧',
    categorySlug: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20set%20in%20Shanghai%201990s%2C%20nostalgic%20golden%20tone%2C%20clean%20white%20background%2C%20high%20quality%20TV%20show%20poster&width=600&height=800&seq=tv-cover-04&orientation=portrait',
    year: 2024,
    rating: 8.9,
    description: '九十年代的上海，遍地是机遇与希望。青年阿宝凭借改革开放的春风和自己的努力，成为商界后起之秀。黄河路上人来人往，每个人都在为自己的梦想奋斗。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '45分钟/集',
    region: '中国大陆',
    type: 'tv',
    episodes: 30,
    updateStatus: '已完结',
    tags: ['剧情', '年代', '商战', '国产剧'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-9',
    title: '封神第一部',
    titleEn: 'Creation of the Gods I',
    category: '动作片',
    categorySlug: 'dongzuo',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20beasts%2C%20epic%20battle%20scene%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-09&orientation=portrait',
    year: 2023,
    rating: 8.0,
    description: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主，以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    duration: '148分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['奇幻', '神话', '古装', '史诗'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-10',
    title: '年会不能停',
    titleEn: 'Johnny Keep Walking',
    category: '喜剧片',
    categorySlug: 'xiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%20with%20office%20workers%20and%20party%20atmosphere%2C%20bright%20colorful%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-10&orientation=portrait',
    year: 2023,
    rating: 8.1,
    description: '钳工胡建林阴差阳错被调入集团总部，在年会上揭露了工厂贪腐、错调等一系列问题，并与人事经理马杰等人一起掀翻一场职场闹剧。',
    director: '董润年',
    cast: ['大鹏', '白客', '庄达菲', '王迅'],
    duration: '117分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['喜剧', '职场', '讽刺', '搞笑'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-11',
    title: '芭比',
    titleEn: 'Barbie',
    category: '喜剧片',
    categorySlug: 'xiju',
    cover: 'https://readdy.ai/api/search-image?query=Barbie%20movie%20poster%20with%20pink%20aesthetic%20and%20Margot%20Robbie%20style%2C%20dreamy%20colorful%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-11&orientation=portrait',
    year: 2023,
    rating: 8.1,
    description: '生活在芭比乐园的经典芭比，因为不太完美而被驱逐，她必须前往现实世界寻找真正的幸福。一场关于自我认知和女性力量的冒险就此展开。',
    director: '格蕾塔·葛韦格',
    cast: ['玛格特·罗比', '瑞恩·高斯林', '亚美莉卡·费雷拉'],
    duration: '114分钟',
    region: '美国',
    type: 'movie',
    tags: ['奇幻', '喜剧', '女性', '冒险'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-12',
    title: '蜘蛛侠：纵横宇宙',
    titleEn: 'Spider-Man: Across the Spider-Verse',
    category: '动画片',
    categorySlug: 'donghua',
    cover: 'https://readdy.ai/api/search-image?query=Spider-Man%20animated%20movie%20poster%20with%20multi-verse%20theme%20and%20comic%20art%20style%2C%20vibrant%20colors%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-12&orientation=portrait',
    year: 2023,
    rating: 8.5,
    description: '新生代蜘蛛侠迈尔斯与蜘蛛格温再次相遇，踏上一场穿越多元宇宙的冒险旅程。在那里，他遇到了一支由蜘蛛侠组成的精英团队，但也必须面对一个全新的威胁。',
    director: '乔伊姆·多斯·桑托斯',
    cast: ['沙梅克·摩尔', '海莉·斯坦菲尔德', '奥斯卡·伊萨克'],
    duration: '140分钟',
    region: '美国',
    type: 'movie',
    tags: ['动画', '超级英雄', '冒险', '多元宇宙'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'movie-13',
    title: '志愿军：雄兵出击',
    titleEn: 'The Volunteers: To the War',
    category: '战争片',
    categorySlug: 'zhanzheng',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20about%20Korean%20War%20with%20soldiers%20marching%2C%20epic%20battlefield%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-13&orientation=portrait',
    year: 2023,
    rating: 7.9,
    description: '1949年建国初期，新中国面临"内忧外患"局面。朝鲜内战爆发以来，美军屡在中朝边境挑衅，平民惨遭轰炸。为了维护来之不易的和平，中国人民志愿军入朝作战。',
    director: '陈凯歌',
    cast: ['唐国强', '王砚辉', '刘劲', '辛柏青'],
    duration: '140分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['战争', '历史', '主旋律', '抗美援朝'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-14',
    title: '铃芽之旅',
    titleEn: 'Suzume',
    category: '动画片',
    categorySlug: 'donghua',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20with%20girl%20and%20mysterious%20door%2C%20beautiful%20sky%20and%20sea%2C%20Makoto%20Shinkai%20style%2C%20clean%20white%20background%2C%20high%20quality&width=600&height=800&seq=movie-cover-14&orientation=portrait',
    year: 2023,
    rating: 8.3,
    description: '17岁少女铃芽遇见了为了寻找"门"而踏上旅途的青年。追随着青年的脚步，铃芽来到了山上一片废墟之地，在这里静静伫立着一扇古老的门，仿佛是坍塌中存留的唯一遗迹。',
    director: '新海诚',
    cast: ['原菜乃华', '松村北斗', '深津绘里'],
    duration: '122分钟',
    region: '日本',
    type: 'movie',
    tags: ['动画', '奇幻', '冒险', '治愈'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-15',
    title: '无名',
    titleEn: 'Hidden Blade',
    category: '悬疑片',
    categorySlug: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20spy%20thriller%20movie%20poster%20set%20in%20WWII%20Shanghai%2C%20noir%20style%2C%20dark%20elegant%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-15&orientation=portrait',
    year: 2023,
    rating: 7.3,
    description: '上世纪二十年代的上海，中国共产党中央特别行动科在隐蔽战线与各方势力殊死较量。在走向胜利的过程中，那些在隐蔽战线上奋斗的无名英雄不可被遗忘。',
    director: '程耳',
    cast: ['梁朝伟', '王一博', '周迅', '黄磊'],
    duration: '128分钟',
    region: '中国大陆',
    type: 'movie',
    tags: ['谍战', '悬疑', '历史', '动作'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-16',
    title: '银河护卫队3',
    titleEn: 'Guardians of the Galaxy Vol. 3',
    category: '科幻片',
    categorySlug: 'kehuan',
    cover: 'https://readdy.ai/api/search-image?query=Marvel%20Guardians%20of%20the%20Galaxy%20movie%20poster%20with%20space%20team%20and%20raccoon%2C%20cosmic%20colorful%2C%20clean%20white%20background%2C%20high%20quality%20movie%20poster&width=600&height=800&seq=movie-cover-16&orientation=portrait',
    year: 2023,
    rating: 8.4,
    description: '彼得·奎尔因失去卡魔拉而心碎，但他必须召集他的团队保卫宇宙，保护他们中的一员。如果任务不完全成功，这很可能导致银河护卫队的终结。',
    director: '詹姆斯·古恩',
    cast: ['克里斯·帕拉特', '佐伊·索尔达娜', '戴夫·巴蒂斯塔'],
    duration: '150分钟',
    region: '美国',
    type: 'movie',
    tags: ['科幻', '超级英雄', '冒险', '漫威'],
    isHot: false,
    isNew: true,
  },
];

export const heroMovies = movies.filter(m => m.isHot).slice(0, 5);

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);
export const allMovies = movies;

export const testimonials = [
  {
    author: '小明',
    rating: 5,
    content: '资源太全了！想看的电影电视剧基本都有，而且画质清晰、播放流畅不卡顿，已经成为我每天睡前必刷的网站了。',
    date: '2024-07-15',
  },
  {
    author: '电影爱好者',
    rating: 5,
    content: '用了很多影视网站，被窝网是最好的一个。界面干净没有乱七八糟的广告，分类清晰，更新速度也很快。强烈推荐！',
    date: '2024-07-20',
  },
  {
    author: '追剧达人',
    rating: 5,
    content: '追剧体验一级棒！新剧更新及时，播放一点不缓冲。特别喜欢按分类找片的功能，省去了很多搜索的时间。',
    date: '2024-07-25',
  },
  {
    author: '闲暇时光',
    rating: 4,
    content: '下班回家就喜欢打开被窝网找部好电影看。资源丰富，高清流畅，陪伴了我无数个美好的夜晚。',
    date: '2024-08-01',
  },
  {
    author: '影迷小陈',
    rating: 5,
    content: '找了好久终于找到一个靠谱的免费电影网站。片源全、更新快、播放流畅，身边的朋友都被我安利了个遍！',
    date: '2024-08-02',
  },
];